import { DefaultPageState } from "../../../../common/models/StoreDefaultModel";

export type OpenStorageItemData = {};

export const initialOpenStoragePageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
